import { type RouteObject } from 'react-router'

import {
  ASK_YOGI_CONVERSATION_TRANSACTION_PATH,
  ASK_YOGI_CONVERSATION_URL,
  ASK_YOGI_SHARE_TRANSACTION_PATH,
  ASK_YOGI_SHARE_URL,
  ASK_YOGI_TRANSACTION_PATH,
  ASK_YOGI_URL,
} from 'features/ask-yogi/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const askYogiPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/ask-yogi/Container'))

export const askYogiRoutes: RouteObject[] = [
  {
    path: ASK_YOGI_URL,
    lazy: askYogiPage(),
    handle: {
      featureKey: ASK_YOGI_URL,
      sentryTransactionPath: ASK_YOGI_TRANSACTION_PATH,
    },
  },
  {
    path: `${ASK_YOGI_URL}/:conversationId/share`,
    lazy: askYogiPage(),
    handle: {
      featureKey: ASK_YOGI_SHARE_URL,
      sentryTransactionPath: ASK_YOGI_SHARE_TRANSACTION_PATH,
    },
  },
  {
    path: `${ASK_YOGI_URL}/:conversationId`,
    lazy: askYogiPage(),
    handle: {
      featureKey: ASK_YOGI_CONVERSATION_URL,
      sentryTransactionPath: ASK_YOGI_CONVERSATION_TRANSACTION_PATH,
    },
  },
]
